<template>
<div class="conteudoInterno">
  <div class="boxSeta">
      <div class="setaScrollstatic" style="" 
          :class="{ 
            setaScroll: setaScrollState 
            }"
      >
        <button><span><i class="bottom"></i></span></button>
      </div> 
  </div>
  <header class="headerSec">
    <h2>A UBC</h2>
    <div class="navSetas">
      <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
      <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
    </div> 
  </header>
  <div class="conteudoInternoBox" ref="infoBox">
    <section class="sectionRow" ref="infoscroll">
      <div class="col23ponto5 marginColBottom">
        <span class="linecol32"></span> 
      </div> 
      <div class="col36 marginColBottom">
        <div class="boxAubc">
          <div class="lineText" style="margin:0 0 30px 0;">
            <img src="../assets/icoaubc1.png" style="margin:0 35px 0 0;" />
            <p>A UBC fechou o ano de 2018 com um total de 29 mil associados, o que representou um crescimento de 14%.</p>
          </div>
          <div class="lineNumbers">
            <div class="numberDest">
              <span>29 MIL</span>
              <span class="numberDestSmall">associados</span>
            </div>
            <span class="linhaSep"></span>
            <div class="numberDest">
              <span>14%</span>
              <span class="numberDestSmall">de crescimento*</span>
            </div>
          </div>
        </div><!-- boxAubc --> 
      </div><!-- col36 -->
      <div class="col36">
        <div class="boxAubc">
          <div class="lineNumbers" style="margin:0 0 30px 0;">
            <div class="numberDest">
              <span>116%</span>
              <span class="numberDestSmall">
                de crescimento no cadastro <br />
                 de obras e fonogramas</span>
            </div>
            <span class="linhaSep"></span>
            <div class="numberDest">
              <span>8 MIL</span>
              <span class="numberDestSmall">
                cue-sheets (85% de <br />
                crescimento*)
              </span>
            </div>
          </div>
          <div class="lineText">
            <img src="../assets/icoaubc2.png" style="margin:0 35px 0 0;" />
            <p>O cadastro de obras e fonogramas apresentou um grande crescimento, na ordem de 116%. Foram 870 mil obras (58% de crescimento), 763 mil fonogramas (270% de crescimento) e 8 mil cue-sheets (85% de crescimento) cadastrados durante o ano. </p>
          </div>
        </div><!-- boxAubc -->  
      </div><!-- col36 -->
    </section>

    <section class="sectionRow" style="margin:20px 0 0 0;">
      <div class="col23ponto5"></div>
      <div class="col74ponto5">
        <div class="notaNumeros">
          <span>*comparado a 2017 </span>
        </div>
      </div>
    </section>

    <section class="sectionRow">
      <div class="col23ponto5"> 
      </div> 

      <div class="col74ponto5 boxLine">
        <span class="linebtsection"></span>
      </div>
    </section>

    <section class="sectionRow">
      <div class="col23ponto5"></div> 
      <div class="col36 marginColBottom">
        <div class="boxAubc">
          <div class="lineText lineTextNf">
             <p>O número de funcionários e estagiários teve uma queda de 5% em relação a 2017 e há um equilíbrio entre homens e mulheres, que representam 50% do quadro funcional.</p>
            <img src="../assets/icoaubc3.png" style="margin:0 0 0 35px;" />
          </div>
          <div class="lineNumbers lineNumbersIgualdade">
            <!-- <div class="numberDest">
              <span>5%</span>
              <span class="numberDestSmall">de aumento</span>
            </div> 
            <span class="linhaSep"></span> -->
            <div class="numberDest numberDestIgualdade">
              <span>50%</span>
              <span class="numberDestSmall numberDestSmallIgualdade">de mulheres</span>
            </div>
          </div>
        </div><!-- boxAubc --> 
      </div><!-- col36 -->
      <div class="col36">
        <div class="boxAubc">
          <div class="lineNumbers" style="margin:0 0 10px 0; justify-content:flex-start;">
            <div class="numberDest" >
              <span>423 MIL</span>
            </div>
          </div>
          <div class="lineText">
            <p>Foi investido um total de R$ 423 mil no programa de assistência que dá ao quadro social mais antigo da UBC uma garantia mínima de remuneração, assistência de saúde e eventuais necessidades de sobrevivência.</p>
            <img src="../assets/icoaubc4.png" />
          </div>
        </div><!-- boxAubc -->  
      </div><!-- col36 -->  
    </section>
  </div>
</div>
</template>

<script>
export default {
  name: 'aUbc',
  props:['clicked'],
  data() {
    return{
      setaScrollState: false,
    }
  },
  destroyed(){  
    this.myStopFunction();
  },
  mounted () {
    this.showSetaScroll();
  },
  methods:{
    showSetaScroll: function(){
      this.refresh = setInterval(() => {
        let alturaTela = window.innerHeight;
        let alturaDiv = this.$refs.infoBox.clientHeight;
        let boxABB = this.$refs["infoscroll"].getBoundingClientRect();
        if(alturaTela - 50 <= alturaDiv && boxABB.top == 148){
          this.setaScrollState = true
        }else{
          this.setaScrollState = false
        }
      }, 1000);
    },
    myStopFunction: function() {
      clearInterval(this.refresh);
    },
    goNext: function(){
      this.$emit("go-next");
    },
    goBack: function(){
      this.$emit("go-back");
    },  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.boxAubc{
  position:relative;
  width: 100%;

}

.boxAubc .lineText{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width:100%;
  position:relative;
}

.boxAubc .lineText p{
  font-size: 14px;
  color:#808285;
}



.boxAubc .lineNumbers{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.boxAubc .lineNumbers .numberDest{
  display:flex;
  flex-direction: column;
}

.boxAubc .lineNumbers .numberDest span{
  color:#168ECD;
  font-size: 4.5vw;
  font-family: 'sanuk-bolditalicregular';
}

.boxAubc .lineNumbers span.numberDestSmall{
  font-size: 1.2vw;
  font-family: sanuklf-regularregular;
}

.boxAubc .lineNumbers span.linhaSep{
  display: block;
  width:1px;
  background-color: #168ECD;
}

.numberDestIgualdade{
  flex-direction: row !important;
}
.numberDestSmallIgualdade{
  align-self: flex-end;
   margin:0 0 1vw 1vw;
   font-size: 1.3vw !important;
}
.lineNumbersIgualdade{
  justify-content: flex-start !important;
}

.lineTextNf{
margin:0 0 30px 0;
}

</style>


// WEBPACK FOOTER //
// src/components/aUbc.vue